import { LocaleEnum } from '@systemeio/ui'

export const getLocaleForLink = (locale?: LocaleEnum) => {
  return locale === LocaleEnum.ENGLISH ? '/' : `/${locale}`
}
